import { call, put, takeLatest } from 'redux-saga/effects';

import { getCardDocumentTypes } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getCardDocumentTypes, action.payload);
  yield put(
    response.isOk ? requestSuccess(response.data, action.payload) : requestFailure(response.error),
  );
}

export default function* cardDocumentTypesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
